import { publicCommonClient } from '../clients';

const searchInterface = {
  getResult: async (centreId) => {
    const { data: results } = await publicCommonClient.get(
      `/api/search/getResult/centre/${centreId}`,
    );

    return results;
  },
};

export default searchInterface;
